// extracted by mini-css-extract-plugin
export default {"container":"Cookies_container__TNXD+","space":"Cookies_space__CrwqB"};